import client from './client';

const techActionUrl = '/api/v1/techAction';

export const getActionList = (usrUuid, searchDate) => {
  return client.get(`${techActionUrl}/list`, {
    params: { usrUuid, searchDate }
  });
};

export const getActionDetail = (activityId) => {
  return client.get(`${techActionUrl}/${activityId}`);
};

export const saveTechAction = (finalData) => {
  return client.post(`${techActionUrl}/save`, finalData);
};

export const deleteTechAction = (params) => {
  return client.post(`${techActionUrl}/delete`, params);
};

// 🏢 👤 [추가] 로그인한 유저 UUID를 던져 부서 리스트와 유저 리스트를 동시에 리턴받는 단일 복합 API
export const getDepartmentAndUserList = (usrUuid) => {
  return client.get(`${techActionUrl}/departmentAndUserList`, {
    params: { usrUuid }
  });
};

export const getActionStat = (dptUuid, usrUuid, startDate, endDate, loginUuid) => 
    client.get(`${techActionUrl}/stats`, {
        params: { dptUuid, usrUuid, startDate, endDate, loginUuid } // ◀ loginUuid 추가
    });

export const getActionStatList = (dptUuid, usrUuid, startDate, endDate, loginUuid) => 
    client.get(`${techActionUrl}/statList`, {
        params: { dptUuid, usrUuid, startDate, endDate, loginUuid } // ◀ loginUuid 추가
    });

export const getActionForecastList = (prjUuid) => 
    client.get(`${techActionUrl}/forecastList`, {
        params: { prjUuid }
    });

export const getProjectList = (usrUuid, searchParams) => {
  return client.get(`${techActionUrl}/projectList`, {
    params: { 
      usrUuid, 
      ...searchParams
    }
  });
};
